import { useNavigate } from 'react-router-dom'
import ActivityLogForm from './ActivityLogForm'
import ActivityLogSummary from './ActivityLogSummary'
import ActivityLogDetail from './ActivityLogDetail'

export default function ActivityLog(props) {
  const { objectTypeId, actionUserId, fromDate, toDate, location } = props
  console.log('ActivityLog rendered: ', props, fromDate, toDate)

  const navigate = useNavigate()
  const locationParams = new URLSearchParams(location.search)
  let start = locationParams.get('start') ? locationParams.get('start') : 1

  function setRoute(inputs) {
    console.log('ActivityLog.setRoute', inputs)
    let params = ''
    if (inputs.objectTypeId || inputs.actionUserId || inputs.fromDate || inputs.toDate) {
      let delimiter = '?'
      for (let inputName in inputs) {
        if (inputs[inputName]) {
          params += `${delimiter}${inputName}=${inputs[inputName]}`
          delimiter = '&'
        }
      }
      params += `${delimiter}start=${start}`
    }
    navigate(`/custom/document_view.display_audit_log${params}`)
  }

  let gridComponent = <ActivityLogSummary parameters={props} />
  if (objectTypeId || actionUserId) {
    gridComponent = <ActivityLogDetail parameters={props} location={props.location} />
  }

  return (
    <div className="activitylog-container">
      <div style={{ height: '100%' }}>
        <div className="activitylog-grid-header">
          <h3>Audit Report</h3>
        </div>
        <ActivityLogForm {...props} setRoute={setRoute} />
        {gridComponent}
      </div>
    </div>
  )
}
